export default {"src":"https://search.testwiggot.com/_next/static/media/monopolio-letters.bfb6a71c.svg","height":13,"width":67,"blurWidth":0,"blurHeight":0};